export const formatNotificationsSettings = ({
  mobileEmails,
  browserEmails,
}: {
  mobileEmails: boolean;
  browserEmails: boolean;
}) => {
  return {
    browser: {
      reminders: {
        mail: browserEmails,
      },
      instant: {
        mail: browserEmails,
      },
    },
    mobile: {
      reminders: {
        mail: mobileEmails,
        fcm: true,
      },
      instant: {
        mail: mobileEmails,
        fcm: true,
      },
    },
  };
};

export const defaultNotificationsSettings = formatNotificationsSettings({
  mobileEmails: true,
  browserEmails: true,
});
